// Mock data for Pégase website

export const heroData = {
  title: "Pégase Liberté",
  subtitle: "Attelage, Accessibilité, Handicap",
  tagline: "Les attelages qui vous donnent des ailes",
  description: "Découvrez la nature sans limites. Nos attelages tout terrain ultra-sécurisés rendent les plus beaux paysages accessibles à tous quel que soit le handicap.",
  images: [
    "https://customer-assets.emergentagent.com/job_equi-mobility/artifacts/rjd2ubev_IMG_6950.jpg",
    "https://customer-assets.emergentagent.com/job_equi-mobility/artifacts/h55otjxx_IMG_6955.jpg",
    "https://customer-assets.emergentagent.com/job_equi-mobility/artifacts/z6xbbfmp_IMG_6956.jpg",
    "https://customer-assets.emergentagent.com/job_equi-mobility/artifacts/eb63j422_IMG_6962.jpg"
  ]
};

export const safetyLevels = [
  {
    id: 1,
    title: "Cordon de sécurité",
    description: "Accessible au meneur ou à la personne en fauteuil. Un simple geste libère instantanément le cheval.",
    icon: "hand"
  },
  {
    id: 2,
    title: "Boîtier à bouton",
    description: "Porté autour du cou du meneur ou accompagnant. Un appui libère le cheval immédiatement.",
    icon: "radio"
  },
  {
    id: 3,
    title: "Distancemètre automatique",
    description: "Si le meneur tombe ou s'éloigne de plus de 10 mètres, le système se déclenche automatiquement.",
    icon: "radar"
  }
];

export const carriages = [
  {
    id: "tapis-volant",
    name: "Tapis Volant / Flying Carpet",
    subtitle: "L'attelage 3 roues pour l'aventure sans limites",
    description: "Conçu principalement pour les personnes en fauteuil roulant, le Tapis Volant ouvre l'accès à des territoires jusqu'alors inaccessibles : plages, dunes, mer, océan, chemins naturels, réserves... Il peut embarquer n'importe quel type de fauteuil (manuel, électrique, médicalisé), grâce à un système qui abaisse le niveau. Le centre de gravité du Flying Carpet étant bas, il est très stable et confortable.",
    weight: "120 kg",
    loadCapacity: "350 kg",
    capacity: "1 à 3 personnes",
    horseType: "Poney ou cheval moyen (ex: Henson 1m60)",
    features: [
      "Utilisable seul en autonomie",
      "À deux (meneur + personne en fauteuil)",
      "À trois (meneur + accompagnant + fauteuil)",
      "Sans fauteuil avec banc amovible",
      "Compatible avec tous types de fauteuils (manuel, électrique, médicalisé)",
      "Système d'abaissement du niveau pour faciliter l'embarquement",
      "Centre de gravité bas pour une grande stabilité",
      "2 jeux de brancards inclus (poney 0,9-1,3m / cheval 1,4-1,7m)"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_equi-mobility/artifacts/rjd2ubev_IMG_6950.jpg",
      "https://customer-assets.emergentagent.com/job_equi-mobility/artifacts/h55otjxx_IMG_6955.jpg"
    ]
  },
  {
    id: "ben-hur",
    name: "Ben-Hur",
    subtitle: "L'attelage 2 roues ultra-maniable",
    description: "Pour un seul meneur avec handicap léger ou non handicapé. Ultra-léger, maniable et amusant, le Ben-Hur se conduit debout et offre une expérience unique.",
    weight: "60 kg",
    capacity: "1 personne (meneur debout)",
    horseType: "Poney ou cheval",
    features: [
      "Très léger et maniable",
      "Conduite debout",
      "Tout terrain",
      "Roues démontables facilement",
      "Transportable en coffre de break",
      "2 jeux de brancards inclus (poney 0,9-1,3m / cheval 1,4-1,7m)"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_equi-mobility/artifacts/z6xbbfmp_IMG_6956.jpg",
      "https://customer-assets.emergentagent.com/job_equi-mobility/artifacts/eb63j422_IMG_6962.jpg"
    ]
  }
];

export const targetAudiences = [
  {
    id: 1,
    title: "Centres Équestres",
    description: "Élargissez votre offre et accueillez un public PMR avec des équipements de pointe.",
    icon: "building"
  },
  {
    id: 2,
    title: "Associations & IME",
    description: "Proposez des activités inclusives en pleine nature à vos membres et bénéficiaires.",
    icon: "users"
  },
  {
    id: 3,
    title: "Centres de Rééducation",
    description: "Intégrez l'équithérapie et les sorties nature dans vos programmes de soins.",
    icon: "heart-pulse"
  },
  {
    id: 4,
    title: "Familles & Particuliers",
    description: "Redécouvrez le plaisir de la nature en famille, sans barrières.",
    icon: "home"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marie L.",
    role: "Utilisatrice Tapis Volant",
    text: "J'ai pu accéder à la plage pour la première fois depuis 10 ans. Une expérience inoubliable !",
    avatar: "ML"
  },
  {
    id: 2,
    name: "Centre Équestre La Baie",
    role: "Professionnel",
    text: "Nos clients adorent ! Le système de sécurité rassure tout le monde, y compris nos chevaux.",
    avatar: "CE"
  },
  {
    id: 3,
    name: "Thomas B.",
    role: "Meneur Ben-Hur",
    text: "C'est incroyablement amusant et maniable. Je peux aller partout !",
    avatar: "TB"
  }
];

export const faqs = [
  {
    id: 1,
    question: "Comment fonctionne le système de sécurité ?",
    answer: "Notre système triple sécurité permet de libérer instantanément le cheval : via un cordon manuel, un boîtier à bouton, ou automatiquement si le meneur s'éloigne de plus de 10 mètres. Zéro stress pour le cheval, sécurité maximale pour les personnes."
  },
  {
    id: 2,
    question: "Quel type de cheval peut tirer ces attelages ?",
    answer: "Le Tapis Volant (120kg) peut être tiré par un poney ou cheval de taille moyenne (testé avec succès par un Henson de 1m60). Le Ben-Hur (60kg) est encore plus léger et adapté à tous types de poneys et chevaux. Deux jeux de brancards sont inclus."
  },
  {
    id: 3,
    question: "Puis-je tester avant d'acheter ?",
    answer: "Oui ! Contactez-nous pour organiser une démonstration ou découvrir nos partenaires équipés près de chez vous."
  },
  {
    id: 4,
    question: "Les attelages sont-ils disponibles à la location ?",
    answer: "Actuellement, nous proposons des pré-commandes pour l'achat. Certains de nos partenaires professionnels proposent des locations. Consultez notre carte des partenaires."
  },
  {
    id: 5,
    question: "Quels terrains sont accessibles ?",
    answer: "Nos attelages sont conçus pour les terrains naturels : plages, dunes, chemins forestiers, réserves naturelles, zones Natura 2000... Partout où les fauteuils classiques ne peuvent pas aller."
  }
];

export const visionContent = {
  story: "Pégase est né d'une conviction : la nature ne devrait avoir aucune barrière. Nous avons créé des attelages qui allient innovation technologique et respect absolu du bien-être animal pour permettre à chacun de vivre l'expérience unique de la nature sauvage. Simon Mulholland travaille depuis plus de 20 ans à l'innovation et la conception d'attelages les plus sûrs possibles. Les derniers développements offrent la possibilité à des personnes en situation de handicap :\n- d'avoir accès à des sites naturels exceptionnels\n- de pouvoir être autonome si ils le souhaitent\n- de découvrir les plaisirs équestres.",
  values: [
    {
      title: "Accessibilité et Nature",
      description: "Rendre les plus beaux paysages naturels accessibles à tous, sans exception."
    },
    {
      title: "Innovation et Sécurité",
      description: "Développer des solutions techniques de pointe pour la sécurité et le confort."
    },
    {
      title: "Respect Animal",
      description: "Garantir le bien-être et la sécurité des chevaux à chaque instant."
    },
    {
      title: "Plaisir",
      description: "Permettre aux personnes en situation de handicap de se faire plaisir."
    }
  ]
};
